import styles from "./DotLoading.module.css";

export default function DotLoading() {
  return (
    <div className={styles.container}>
      <div className={`${styles.dotflashing}`}></div>
    </div>
  );
}
